import { useFailureToastWithRefresh } from '@flowwai-frontend/bps-officer-web/common/data-access'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

import { GSFieldType } from '../../types'

import { GetFieldsWithSystemFieldEnumQuery as Query } from './query.generatedTypes'

interface ReturnType {
   fields: GSFieldType[]
}

const useAPIResponseHandler = (data?: Query): ReturnType => {
   const fields: GSFieldType[] = []

   const { showFailureToastWithRefresh } = useFailureToastWithRefresh()
   const t = useCustomT('globalSearch:searchModal')

   if (!data)
      return {
         fields
      }

   const onClickRefresh = (): void => {
      window.location.reload()
   }

   const fieldsData = data.searchFields

   switch (fieldsData.__typename) {
      case 'SalesTemplateFieldsResult': {
         fieldsData.salesTemplateFields.forEach(template => {
            template.fields.forEach(field => {
               switch (field.__typename) {
                  case 'PhoneNumberField':
                     fields.push(field)
                     break
                  default:
                     throw new Error(`Unhandled union type ${field.__typename}`)
               }
            })
         })
         break
      }
      case 'PipelineAccessDenied': {
         const title = t('pipelineAccessDenied.title')
         const message = t('pipelineAccessDenied.description')
         showFailureToastWithRefresh(title, message, onClickRefresh)
         break
      }
      default:
         throw new Error(`Unhandled union type ${fieldsData.__typename}`)
   }

   return {
      fields
   }
}

export default useAPIResponseHandler
